import $ from 'jquery'
import 'jquery-touchswipe'

export const renderPriceDecrease = (
  wrapper = document.querySelector('.price-decrease-widget'),
) => {
  // Select by default first element.
  $('#switch_2', wrapper).prop('checked', true)

  $('input', wrapper).each(function () {
    $(this).on('click, change', function () {
      $('.deneme-sales', wrapper).text($(this).attr('data-label'))
      $('.change-num', wrapper).text($(this).attr('data-night'))
      hideShowArrow()
    })
  })

  // Show/hide arrow on left and right last elements.
  function hideShowArrow() {
    if ($('#switch_2', wrapper).is(':checked')) {
      $('.arrow-left', wrapper).hide()
    } else {
      $('.arrow-left', wrapper).show()
    }
    if ($('#switch_4', wrapper).is(':checked')) {
      $('.arrow-right', wrapper).hide()
    } else {
      $('.arrow-right', wrapper).show()
    }
  }

  hideShowArrow()

  // Left arrow handler.
  $('.arrow-right', wrapper).click(() => {
    if ($('#switch_2', wrapper).is(':checked')) {
      $('#switch_3', wrapper).trigger('click')
    } else if ($('#switch_3', wrapper).is(':checked')) {
      $('#switch_4', wrapper).trigger('click')
    } else if ($('#switch_4', wrapper).is(':checked')) {
      $('#switch_1', wrapper).trigger('click')
    }
  })

  // Right arrow handler.
  $('.arrow-left', wrapper).click(() => {
    if ($('#switch_1', wrapper).is(':checked')) {
      $('#switch_4', wrapper).trigger('click')
    } else if ($('#switch_4', wrapper).is(':checked')) {
      $('#switch_3', wrapper).trigger('click')
    } else if ($('#switch_3', wrapper).is(':checked')) {
      $('#switch_2', wrapper).trigger('click')
    }
  })

  // Swipe handler.
  $(wrapper).swipe({
    swipeLeft: () => $('.arrow-left', wrapper).click(),
    swipeRight: () => $('.arrow-right', wrapper).click(),
  })
}
